import { useEffect, useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { usePrevious } from 'react-use';
import { useErrorLogService } from 'ErrorLogging';
import { type PretendAiMessage } from '../types/ChatMessage.types';
import { getActiveConversationId, chatActions } from '../redux/chat';
import { createPretendAiMessage } from '../utils/ChatMessage';
import { useChatContext } from '../Chat/ChatContext';

export const LockedAiAdvisorMessage: FC = () => {
    const [greetingIndex, setGreetingIndex] = useState(0);
    const prevGreetingIndex = usePrevious(greetingIndex);
    const { tutorBotStatusConfig } = useChatContext();
    const ErrorLogService = useErrorLogService();
    const { t } = useTranslation('back_royal');
    const dispatch = useDispatch();
    const activeConversationId = useSelector(getActiveConversationId);

    useEffect(() => {
        const greetingMessage = tutorBotStatusConfig.greetingMessages[greetingIndex];

        if (!greetingMessage || prevGreetingIndex === greetingIndex) return;

        setTimeout(
            () => {
                const message: PretendAiMessage = createPretendAiMessage({
                    conversationId: activeConversationId!,
                    content: t(greetingMessage.key, greetingMessage.params ?? {}),
                });

                dispatch(chatActions.addMessage({ message }));
                setGreetingIndex(prev => prev + 1);
            },
            greetingIndex === 0 ? 0 : 1350,
        );
        // tried adding a cleanup function to clear the timeout, but it was running too often and prevented messages
    }, [
        greetingIndex,
        setGreetingIndex,
        prevGreetingIndex,
        tutorBotStatusConfig,
        activeConversationId,
        dispatch,
        t,
        ErrorLogService,
    ]);

    // This component is only rendered when we are supposed to show locked-state greeting messages.
    // It doesn't itself render anything - it just dispatches the messages to the store because we
    // are wanting to treat these messages as part of the actual conversation history/context.
    return null;
};
